/** Handoff / send-lifecycle statuses on a marketplace order. */
export const MARKETPLACE_ORDER_STATUS_SENT = "SENT" as const;

export const MARKETPLACE_ORDER_LIVE_HANDOFF_STATUSES = [
  "PENDING_SEND",
  "SENDING",
  "FAILED",
  "AWAITING_VENDOR",
] as const;

export type MarketplaceOrderHandoffStatus =
  | (typeof MARKETPLACE_ORDER_LIVE_HANDOFF_STATUSES)[number]
  | typeof MARKETPLACE_ORDER_STATUS_SENT
  | "NOT_REQUIRED";

/** Vendor email has landed. PENDING_SEND / SENDING / FAILED are not sent. */
export function isOrderScriptSent(
  row: { status: string } | null | undefined,
): boolean {
  return row?.status === MARKETPLACE_ORDER_STATUS_SENT;
}
